import { useCustomerBranding } from '@/hooks/use-customer-branding';

const APP_VERSION = import.meta.env.PACKAGE_VERSION;

/**
 * Present on every page (UI_UX_STANDARDS Footer). Stacks on phones, sits in
 * one row from `sm`; below `lg` it lives inside the scroll area above the
 * bottom tab bar so it never competes with, or is hidden by, navigation.
 */
export function CustomerPortalFooter() {
  const { brandName } = useCustomerBranding();

  return (
    <footer className="shrink-0 border-t border-customer-border bg-customer-surface px-4 py-3 text-xs text-customer-text-secondary sm:px-6">
      <div className="mx-auto flex max-w-7xl flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
        <span className="truncate">{brandName} · Customer Portal</span>
        <span className="shrink-0 tabular-nums">Version {APP_VERSION}</span>
      </div>
    </footer>
  );
}
